import React from 'react';
import { useStore } from 'effector-react';
import { SandTableType } from '@types';
import { $curSandTable } from '@stores/dataStores';
import SandTablePlayerMap from '../SandTablePlayerMap';
import SandTablePlayerImage from '../SandTablePlayerImage';

function SandTablePlayer() {
  const data = useStore($curSandTable);

  if (!data) return null;
  const { type } = data;

  if (type === SandTableType.map) return <SandTablePlayerMap data={data} />;
  if (type === SandTableType.image || type === SandTableType.matrix) {
    return <SandTablePlayerImage data={data} />;
  }
  return null;
}

export default SandTablePlayer;
